var ProductReviews, base, base1, base2,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

ProductReviews.PastPurchases = (base = window.ProductReviews).PastPurchases != null ? base.PastPurchases : base.PastPurchases = {};

ProductReviews.PastPurchases.Views = (base1 = window.ProductReviews.PastPurchases).Views != null ? base1.Views : base1.Views = {};

if ((base2 = ProductReviews.PastPurchases).Templates == null) {
  base2.Templates = {};
}

ProductReviews.PastPurchases.Templates['past_purchase'] = require('../../past_purchase.html.mustache');

ProductReviews.Views.ProductReview = require('./product_review');

ProductReviews.PastPurchases.Views.PastPurchase = (function(superClass) {
  extend(PastPurchase, superClass);

  function PastPurchase() {
    return PastPurchase.__super__.constructor.apply(this, arguments);
  }

  PastPurchase.prototype.events = {
    'mouseover .allow-submission .review-star': 'hoverStar',
    'click .allow-submission .review-star': 'clickStar',
    'mouseout .user-rating': 'clearHoverStar',
    'keyup .product-reviews-form-extension textarea': 'updateLengthNotification',
    'click .product-reviews-form-extension button': 'submitReview',
    'click .product-reviews-form-extension a': 'cancelReview',
    'click .review-delete': 'deleteReview',
    'click .review-share': 'showShareTooltip'
  };

  PastPurchase.prototype.initialize = function() {
    if (this.$el == null) {
      this.$el = $(this.el);
    }
    this.$userReview = this.$el;
    this.listenTo(this.model, 'change:rating', this.updateStars);
    return this.initializeMessages();
  };

  PastPurchase.prototype.render = function() {
    var data;
    data = _.extend({}, this.model.attributes, {
      translate: function() {
        return function(text) {
          return I18n.t("js." + text);
        };
      }
    });
    this.userReviewEl = this.$el.selector;
    this.$el.append(ProductReviews.PastPurchases.Templates['past_purchase'].render(data));
    this.$userRating = this.$el.find('.user-rating');
    this.$ratingDescription = this.$el.find('.rating-description');
    this.$userReviewNotification = this.$el.find('.user-review-notification');
    this.$reviewFormExtension = this.$el.find('.product-reviews-form-extension');
    this.$reviewFormExtensions = this.$el.find('.product-reviews-form-extension');
    this.$reviewText = this.$el.find('.product-reviews-form-extension textarea');
    this.$reviewTextCount = this.$el.find('.product-reviews-form-extension .text-count');
    this.$reviewSubmit = this.$el.find('.product-reviews-form-extension button');
    this.$reviewCancel = this.$el.find('.product-reviews-form-extension a');
    return this;
  };

  PastPurchase.prototype.clickStar = function(e) {
    this.hideTooltips();
    this.model.set('rating', $(e.currentTarget).data('star-rating'));
    return this.model.collection.each((function(_this) {
      return function(pastPurchase) {
        if (pastPurchase.id === _this.model.id) {
          return pastPurchase.view.$reviewFormExtension.slideDown('slow');
        } else {
          return pastPurchase.view.cancelReview();
        }
      };
    })(this));
  };

  PastPurchase.prototype.cancelReview = function() {
    return this.resetForm();
  };

  PastPurchase.prototype.deleteReview = function(e) {
    this.resetNotifications();
    return this.model["delete"]();
  };

  return PastPurchase;

})(ProductReviews.Views.ProductReview);

module.exports = ProductReviews.PastPurchases.Views.PastPurchase;

//# sourceMappingURL=data:application/json;base64,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
